import { render, staticRenderFns } from "./NatureMainPopup.vue?vue&type=template&id=315e6718&"
import script from "./NatureMainPopup.vue?vue&type=script&lang=js&"
export * from "./NatureMainPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports